import { LeadDTO, LeadPostDTO } from "@gymflow/types";
import { mutationOptions, QueryKey, queryOptions } from "@tanstack/react-query";

import { api } from "../../api";
import { queryClient } from "../../QueryClient";

const keys = {
  all: () => ["staffApiLead"] as QueryKey,
  id: (userId: unknown) => [...keys.all(), userId] as QueryKey,
};
export const staffApiLead = {
  keys: keys,
  queries: {
    id: (userId: number | undefined) =>
      queryOptions({
        queryKey: keys.id(userId),
        queryFn: async () => {
          return (await api.get<LeadDTO>(`/user/lead/${userId}`)).data;
        },
        enabled: !!userId,
      }),
  },
  mutations: {
    create: () =>
      mutationOptions({
        mutationFn: async (data: LeadPostDTO) => {
          return (await api.post<LeadDTO>("/lead", data)).data;
        },
      }),
    id: () =>
      mutationOptions({
        mutationFn: async ({
          userId,
          patch,
        }: {
          userId: number;
          patch: Partial<LeadPostDTO>;
        }) => {
          return (await api.patch(`/user/lead/${userId}`, patch)).data;
        },
        onSettled: async (_, __, { userId }) => {
          await queryClient.invalidateQueries({ queryKey: keys.id(userId) });
        },
      }),
  },
};
